import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',

    width: '100%',
    overflow: 'auto',

    // Matches the horizontal padding the settings detail layout applies to its title.
    paddingRight: '1.5rem',
    paddingBottom: '2.5rem',
    paddingLeft: '1.5rem',
});
